import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { Loader2, AlertTriangle } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const sessionId = location.hash.split("session_id=")[1]?.split("&")[0];
    if (!sessionId) {
      setError("Sign-in could not be completed. Please try again.");
      return;
    }

    axios
      .get(`${API}/auth/session`, { params: { session_id: sessionId } })
      .then((res) =>
        navigate("/admin", { state: { user: res.data }, replace: true })
      )
      .catch(() => setError("Sign-in failed. Please try again."));
  }, [location.hash, navigate]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[#05060a] px-6 text-center">
      {error ? (
        <div className="glass max-w-sm rounded-3xl p-8" data-testid="auth-callback-error">
          <AlertTriangle className="mx-auto h-8 w-8 text-rose-400" />
          <p className="mt-4 text-sm text-slate-300">{error}</p>
          <Link
            to="/admin"
            data-testid="auth-error-retry"
            className="btn-primary mt-6 inline-flex items-center rounded-full px-6 py-3 text-sm font-semibold text-white"
          >
            Back to Sign In
          </Link>
        </div>
      ) : (
        <div data-testid="auth-callback-loading">
          <Loader2 className="mx-auto h-8 w-8 animate-spin text-indigo-300" />
          <p className="mt-4 font-mono text-xs uppercase tracking-[0.3em] text-slate-500">
            Signing you in…
          </p>
        </div>
      )}
    </div>
  );
}
